import React from "react";

const SlopeUphill = ({ className }) => {
	return (
		<svg
			className={className}
			xmlns="http://www.w3.org/2000/svg"
			width="21.303"
			height="18.683"
			viewBox="0 0 21.303 18.683"
		>
			<g id="slope-uphill" transform="translate(-3)">
				<path
					id="slope-uphill-2"
					data-name="slope-uphill"
					d="M23.3,13.556v9.586H2v-3.2l21.3-6.391m-.341-6.327L17.828,4.46l.895,2.961-10.779,3.2a3.086,3.086,0,1,0-.66,4.314A3.044,3.044,0,0,0,8.54,12.587l10.779-3.2.895,2.961Z"
					transform="translate(1 -4.46)"
					fill="#fff"
				/>
			</g>
		</svg>
	);
};

export default SlopeUphill;
